import request from '@/utils/request'

export function getPackages() {
  return request({
    url: '/ewallet/package/safegate',
    method: 'get'
  })
}

export function getBalance() {
  return request({
    url: '/ewallet/wallet/safegate/balance',
    method: 'get'
  })
}

export function topup(id) {
  return request({
    url: `/ewallet/package/safegate/${id}/pay`,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/ewallet.js